import React, { memo, useCallback, useContext, useMemo, useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import "../ModalEmbarques/ModalEmbarques.css";
import { useNomeTabela } from "../../contexts/NomeTabela.tsx";
import CloseIcon from "../CloseIcon/CloseIcon";
import { useNavigate } from "react-router-dom";
import DadosContextoEmbarqueRedux from "../../contexts/ContextoEmbarque";
import SearchIcon from "@mui/icons-material/Search";
import { useProfile } from "../../contexts/ProfileContext.tsx";

export interface SimpleDialogProps {
  titulo: string;
  tituloBotao: string;
  tituloConfirmar: string;
  texto: string;
  dataAlteracao: string;
  open: boolean;
  listaEmbarques: any[];
  onClose: () => void;
  onClick: () => void;
  buscarEmbarques: () => void;
  setPesquisa: (e) => void;
  pesquisa: string;
}

function ModalEmbarques({
  titulo,
  pesquisa,
  setPesquisa,
  listaEmbarques,
  buscarEmbarques,
  open,
  onClose,
}: SimpleDialogProps) {
  const { dadosTabelaRedux } = useNomeTabela();
  const navigate = useNavigate();
  const { handleSetContextoEmbarque, contextoEmbarque } = useProfile();

  const handleClose = useCallback(() => {
    onClose();
  }, [onClose]);

  const navegarEdicaoEmbarque = useCallback(
    (row) => {
      handleSetContextoEmbarque(row.contexto);
      navigate(`/viagens/${row.contexto}/cadastro/${row.idEmbarque}`);
    },
    [navigate, handleSetContextoEmbarque]
  );

  const formatarData = useCallback((data) => {
    if (data === "2000-01-01T00:00:00" || !data) return "";
    const dataObj = new Date(data);
    return new Intl.DateTimeFormat("pt-BR", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    }).format(dataObj);
  }, []);

  const colunasFiltradas = useMemo(() => {
    return dadosTabelaRedux.Embarque.filter(
      (coluna) => coluna.field !== "descricao"
    );
  }, [dadosTabelaRedux.Embarque]);

  return (
    <Dialog open={open} onClose={handleClose}>
      <div className="div-modal-embarques-disponiveis">
        <DialogTitle id="alert-dialog-title">
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              gap: "10px",
              marginTop: "20px",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {titulo}
            <CloseIcon onClick={handleClose} />
          </div>
          <div
            style={{
              position: "relative",
              width: "100%",
              alignItems: "center",
              justifyContent: "center",
              display: "flex",
            }}
          >
            <input
              type={"number"}
              className="input-filtro-data-v2"
              value={pesquisa}
              placeholder="Informar Raio em KM"
              style={{ width: 200 }}
              onChange={(e) => {
                setPesquisa(e.target.value);
              }}
              id="embarque"
            />
            <SearchIcon
              style={{
                position: "absolute",
                left: 275,
                top: 5,
                cursor: "pointer",
              }}
              onClick={buscarEmbarques}
            />
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              gap: "10px",
              marginTop: "5px",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <p>
              Raio utilizado na busca de embarques próximos a distância
              informada
            </p>
          </div>
        </DialogTitle>
        <div className="outer-wrapper-diaria-veiculo">
          <div className="table-wrapper-diaria-veiculo" id="tableWrapper">
            <table className="tabela-diaria-veiculo">
              <thead>
                <tr>
                  {colunasFiltradas.map((coluna, index) => (
                    <th
                      key={`${coluna.nomeColuna}-${index}`}
                      className="th-diaria-veiculo"
                    >
                      {coluna.nomeColuna}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {listaEmbarques.map((linha) => (
                  <tr
                    key={linha.idEmbarque}
                    className="tr-hover"
                    onDoubleClick={() => {
                      if (window.location.href.endsWith("diaria-veiculos")) {
                        navegarEdicaoEmbarque(linha);
                      }
                    }}
                  >
                    {colunasFiltradas.map((coluna, colIndex) => (
                      <td
                        key={coluna.field ?? "" + colIndex}
                        className="td-diaria-veiculo"
                      >
                        {coluna.field === "empresa" &&
                          linha?.empresaEmbarque?.nome}
                        {coluna.field === "filial" &&
                          linha?.filialEmbarque?.nome}
                        {coluna.field === "rota" && (
                          <>
                            {
                              linha.pedidoEmbarque.rota.cidadeOrigemRota
                                .abreviacao
                            }{" "}
                            -{" "}
                            {linha.pedidoEmbarque.rota.cidadeOrigemRota.estado}
                            <br />
                            {
                              linha.pedidoEmbarque.rota.cidadeDestinoRota
                                .abreviacao
                            }{" "}
                            -{" "}
                            {linha.pedidoEmbarque.rota.cidadeDestinoRota.estado}
                          </>
                        )}
                        {coluna.field === "pedido" &&
                          linha.pedidoEmbarque.pedido}
                        {[
                          "previsaoEmbarque",
                          "previsaoEntrega",
                          "dataHoraChegadaEmbarque",
                          "dataHoraEmbarcado",
                          "dataHoraChegadaEntrega",
                          "dataHoraEntregue",
                        ].includes(coluna.field ?? "") &&
                          formatarData(linha[coluna.field ?? ""])}
                        {coluna.field !== "empresa" &&
                          coluna.field !== "filial" &&
                          coluna.field !== "rota" &&
                          coluna.field !== "pedido" &&
                          ![
                            "previsaoEmbarque",
                            "previsaoEntrega",
                            "dataHoraChegadaEmbarque",
                            "dataHoraEmbarcado",
                            "dataHoraChegadaEntrega",
                            "dataHoraEntregue",
                          ].includes(coluna.field ?? "") &&
                          linha[coluna.field ?? ""]}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </Dialog>
  );
}

export default memo(ModalEmbarques);
